import MarketingSliderSlide, { MARKETING_TYPE } from './MarketingSliderSlide';

export default MarketingSliderSlide;
export { MARKETING_TYPE };
